import { registerQuery } from 'data-fetching-client';
import HttpClient from 'flow-doctor-lib/constants/HttpClient';
export const GET_LEGACY_INTEGRATION_EVENTS = registerQuery({
  fieldName: 'legacyIntegrationEvents',
  args: ['portalId'],
  fetcher({
    portalId
  }) {
    return HttpClient.get('integrators/v1/portal-installs/event-types', {
      query: {
        portalId
      },
      headers: {
        'X-Origin-UserId': 12345
      }
    });
  }
});
export const GET_LEGACY_INTEGRATION_EVENT_PROPERTIES = registerQuery({
  fieldName: 'legacyIntegrationEventProperties',
  args: ['portalId', 'eventId'],
  fetcher({
    portalId,
    eventId
  }) {
    return HttpClient.post('integrators/v1/portal-installs/event-types/properties', {
      query: {
        portalId
      },
      data: {
        ids: [eventId]
      },
      headers: {
        'X-Origin-UserId': 12345
      }
    });
  }
});
export const GET_APP_DETAILS_BY_APPID = registerQuery({
  fieldName: 'appDetailsByAppId',
  args: ['appId'],
  fetcher({
    appId
  }) {
    return HttpClient.get(`apps-hublets/internal/public/v3/${appId}`);
  }
});